import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { APLCategory } from 'src/app/components/apl/services/apl-category.model';
import { CatalogService } from 'src/app/components/catalogs/catalog-service';
import { PendingCatalogType } from 'src/app/services/pending-approvals/pending-approval';
import { APLContainer } from '../../services/apl-container.model';

@Component({
  selector: 'apl-category-v2-list',
  templateUrl: './apl-category-v2-list.component.html',
  styleUrls: ['./apl-category-v2-list.component.scss']
})
export class AplCategoryV2ListComponent implements OnInit, OnChanges, OnDestroy {

  @Input() filter?: string;
  @Input() aplCategories?: APLCategory[];
  @Input() aplContainers?: APLContainer[];

  id: string | null = null;

  displayedColumns: string[] = ['name'];
  sortMode: 'typeOrder' | 'alpha' = 'typeOrder';
  dataSource!: MatTableDataSource<APLCategory>;

  constructor(private route: ActivatedRoute, private catalog: CatalogService) { }
  ngOnDestroy(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.sortCategories();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id)
        this.openCategory(+id);
      else if (this.catalog.pendingCatalog?.approvalType == PendingCatalogType.APLCategories) {
        this.openCategory(this.catalog.pendingCatalog.id);
      }
      else if (this.catalog.pendingCatalog?.approvalType == PendingCatalogType.APLGroups) {
        const aplCategory = this.aplCategories?.find(c => c.aplGroups?.find(g => g.id == this.catalog.pendingCatalog?.pendingID));
        if (aplCategory)
          this.openCategory(aplCategory.id);
      }
    });
  }

  ngOnInit(): void {

  }

  onSortModeChange(e: any) {
    this.sortMode = e.checked ? 'alpha' : 'typeOrder';
    this.sortCategories();
  }

  sortCategories() {
    if (this.aplCategories) {
      if (this.sortMode === 'typeOrder') {
        // Sort by type (0 last) then by aplCategoryMaster.order
        this.aplCategories.sort((a, b) => {
          if (a.type === 0 && b.type !== 0) return 1;
          if (b.type === 0 && a.type !== 0) return -1;
          if (a.type !== b.type) return a.type - b.type;
          return a.aplCategoryMaster.order - b.aplCategoryMaster.order;
        });
      } else {
        // Sort alphanumerically by code
        this.aplCategories.sort((a, b) =>
          a.code.localeCompare(b.code, undefined, { numeric: true, sensitivity: 'base' })
        );
      }

      // Refresh the dataSource
      this.dataSource = new MatTableDataSource([...this.aplCategories]);
    }
  }

  openCategory(aplCategoryID: number) {
    setTimeout(() => {
      // Find the parent container and the selected category
      const parentContainer = this.aplContainers?.find(container =>
        container.aplCategories?.some(cat => cat.id === aplCategoryID)
      );

      if (!parentContainer) return;

      const selectedCategory = parentContainer.aplCategories.find(cat => cat.id === aplCategoryID);
      if (!selectedCategory) return;

      const isAlreadyOpen = selectedCategory.open;

      if (isAlreadyOpen) {
        // Close the selected category if it's already open
        selectedCategory.open = false;
      } else {
        // Open selected container and category, close others
        this.aplContainers?.forEach(container => {
          container.open = (container === parentContainer);
          container.aplCategories?.forEach(cat => {
            cat.open = (cat.id === aplCategoryID);
          });
        });
        // Scroll the newly opened category into view
        setTimeout(() => {
          const divElement = document.getElementById(aplCategoryID.toString());
          if (divElement) {
            divElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 300);
      }
    }, 100);
  }

}
